export type ActId =
  | "act-0"
  | "transition"
  | "act-i"
  | "act-ii"
  | "act-iii"
  | "act-iv"
  | "act-v"
  | "act-vi";

export interface ActDefinition {
  id: ActId;
  label: string;
  start: number;
  end: number;
  redLines: readonly string[];
}

export const ACTS: readonly ActDefinition[] = [
  { id: "act-0", label: "Deep Space", start: 0, end: 0.12, redLines: ["noCube", "noBridge", "noGrid", "noLights"] },
  { id: "transition", label: "How It Works", start: 0.12, end: 0.18, redLines: [] },
  { id: "act-i", label: "AI Chat", start: 0.18, end: 0.598, redLines: [] },
  { id: "act-ii", label: "Code To Cube", start: 0.598, end: 0.715, redLines: [] },
  { id: "act-iii", label: "2D To 3D Break", start: 0.715, end: 0.855, redLines: [] },
  { id: "act-iv", label: "Bridge", start: 0.855, end: 0.942, redLines: [] },
  { id: "act-v", label: "Blender", start: 0.942, end: 0.996, redLines: [] },
  { id: "act-vi", label: "Metaverse", start: 0.996, end: 1, redLines: [] },
] as const;
